import { createFileRoute, useNavigate } from "@tanstack/react-router";
import { z } from "zod";
import { CollectionsFieldsEditor } from "@/components/custom-fields/collections-fields-editor/index";
import { RouteGuardPermissions } from "@/components/permissions/route-guard-multiple";

// `collections/index.tsx` (no `collections.tsx`): así esta página no es la
// ruta padre de `collections/schema` ni de `collections/config/$collectionId`.
export const Route = createFileRoute(
  "/_authenticated/settings/_layout/collections/",
)({
  // `?table=invoices`: abre esa tabla del sistema (p. ej. al volver del
  // editor de plantillas PDF).
  validateSearch: z.object({ table: z.string().optional() }),
  component: CollectionsSettingsPage,
});

function CollectionsSettingsPage() {
  const { table } = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  return (
    <RouteGuardPermissions
      permissions={[{ module: "custom_fields", actions: ["read", "update"] }]}
      // Sin permiso de configuración: quien usa colecciones entra a configurar
      // solo sus colecciones privadas (el editor y el servidor lo limitan).
      alternatives={[[{ module: "collection_records", actions: ["read"] }]]}
    >
      <div className="flex flex-1 flex-col gap-2 min-h-0 overflow-hidden">
        <CollectionsFieldsEditor
          initialTable={table}
          // La seleccion queda en la URL (recargar o compartir abre la misma tabla).
          onSelectionChange={(key) => void navigate({ search: { table: key || undefined }, replace: true })}
        />
      </div>
    </RouteGuardPermissions>
  );
}
